import styled from "styled-components";

export type BadgeTone =
  | "neutral"
  | "primary"
  | "green"
  | "red"
  | "orange"
  | "blue"
  | "purple";

const foreground = (theme: any, tone: BadgeTone): string =>
  tone === "neutral" ? theme.secondaryTextColor : theme.colors[tone];

const softBackground = (theme: any, tone: BadgeTone): string =>
  tone === "neutral" ? theme.surfaceActive : theme.colors[`${tone}Soft`];

// Small status label. Soft by default, `$solid` for use on top of media.
const Badge = styled.span<{ $tone?: BadgeTone; $solid?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.01em;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: ${(props) =>
    props.$solid ? "#fff" : foreground(props.theme, props.$tone ?? "neutral")};
  background: ${(props) =>
    props.$solid
      ? props.$tone && props.$tone !== "neutral"
        ? props.theme.colors[props.$tone]
        : "rgba(17, 19, 24, 0.72)"
      : softBackground(props.theme, props.$tone ?? "neutral")};
  ${(props) =>
    props.$solid
      ? "box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3); backdrop-filter: blur(6px);"
      : ""}

  svg {
    width: 12px;
    height: 12px;
  }
`;

export default Badge;
